import cx from 'classnames'

import { type GalleryCarouselItem } from '@lib/gallery'

import Photo from '@components/photo'

interface GalleryCarouselThumbnailProps {
  item: GalleryCarouselItem
  isSelected?: boolean
  onClick?: () => void
}

const GalleryCarouselThumbnail = ({
  item,
  isSelected,
  onClick,
}: GalleryCarouselThumbnailProps) => {
  switch (item.type) {
    case 'image': {
      return (
        <button
          onClick={onClick}
          className={cx(
            'carousel-thumbnail hover:opacity-60 duration-300 transition-opacity',
            {
              'opacity-60': isSelected,
            },
          )}
        >
          <Photo
            image={item.image}
            fill
            sizes="96px"
            className="relative w-14 h-14 xs:h-20 xs:w-20 md:w-24 md:h-24"
            imageClassName="object-cover"
          />
        </button>
      )
    }

    case '3d-preview': {
      return (
        <button
          onClick={onClick}
          className={cx(
            'carousel-thumbnail hover:opacity-60 duration-300 transition-opacity',
            {
              'opacity-60': isSelected,
            },
          )}
        >
          <div className="flex justify-center items-center w-14 h-14 xs:h-20 xs:w-20 md:w-24 md:h-24 bg-[#F9F9FB]">
            {/* TODO: Fix thumbnail look. */}
            <span>
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.5">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.6485 10.0772C19.8707 9.97428 20.1267 9.97428 20.3489 10.0772L28.6822 13.9368C28.9769 14.0732 29.1654 14.3683 29.1654 14.693V24.3422C29.1654 24.6395 29.0069 24.9143 28.7495 25.0633L20.4162 29.8878C20.158 30.0373 19.8394 30.0373 19.5812 29.8878L11.2478 25.0633C10.9905 24.9143 10.832 24.6395 10.832 24.3422V14.693C10.832 14.3683 11.0206 14.0732 11.3151 13.9368L19.6485 10.0772ZM12.4987 16.0435L19.1654 19.3885V27.7213L12.4987 23.8617V16.0435ZM20.832 27.7213L27.4987 23.8617V16.0435L20.832 19.3885V27.7213ZM19.9987 17.942L26.414 14.723L19.9987 11.7517L13.5834 14.723L19.9987 17.942Z"
                    fill="#0C0C0C"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.16797 4.99996C4.16797 4.53973 4.54107 4.16663 5.0013 4.16663H10.0013C10.4615 4.16663 10.8346 4.53973 10.8346 4.99996C10.8346 5.46019 10.4615 5.83329 10.0013 5.83329H5.83464V9.99996C5.83464 10.4602 5.46154 10.8333 5.0013 10.8333C4.54107 10.8333 4.16797 10.4602 4.16797 9.99996V4.99996Z"
                    fill="#0C0C0C"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.0013 4.16663C35.4615 4.16663 35.8346 4.53973 35.8346 4.99996V9.99996C35.8346 10.4602 35.4615 10.8333 35.0013 10.8333C34.5411 10.8333 34.168 10.4602 34.168 9.99996V5.83329H30.0013C29.5411 5.83329 29.168 5.46019 29.168 4.99996C29.168 4.53973 29.5411 4.16663 30.0013 4.16663H35.0013Z"
                    fill="#0C0C0C"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.0013 35.8333C4.54107 35.8333 4.16797 35.4601 4.16797 35V30C4.16797 29.5398 4.54107 29.1666 5.0013 29.1666C5.46154 29.1666 5.83464 29.5398 5.83464 30V34.1666H10.0013C10.4615 34.1666 10.8346 34.5398 10.8346 35C10.8346 35.4601 10.4615 35.8333 10.0013 35.8333H5.0013Z"
                    fill="#0C0C0C"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.8346 35C35.8346 35.4601 35.4615 35.8333 35.0013 35.8333H30.0013C29.5411 35.8333 29.168 35.4601 29.168 35C29.168 34.5398 29.5411 34.1666 30.0013 34.1666H34.168V30C34.168 29.5398 34.5411 29.1666 35.0013 29.1666C35.4615 29.1666 35.8346 29.5398 35.8346 30V35Z"
                    fill="#0C0C0C"
                  />
                </g>
              </svg>
            </span>
          </div>
        </button>
      )
    }
  }

  return null
}

export default GalleryCarouselThumbnail
